import React, { useEffect, useState, useContext } from "react";

import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';
import LooksTwoOutlinedIcon from '@mui/icons-material/LooksTwoOutlined';
import Looks3OutlinedIcon from '@mui/icons-material/Looks3Outlined';

import { Icon } from 'react-icons-kit'
import { numberOne } from 'react-icons-kit/metrize/numberOne';
import { numberTwo } from 'react-icons-kit/metrize/numberTwo';
import { numberThree } from 'react-icons-kit/metrize/numberThree';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Modal from '@mui/material/Modal';
import LoadingInfynito from "../Shared/LoadingInfynito";
import Box from '@mui/material/Box';

import { Parser } from 'html-to-react';
import FooterFerrettiInfynito from "../Home/FooterFerrettiInfynito";

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";

export const Intro = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [urlMainImage, setUrlMainImage] = useState("");

    const [customizationData, setCustomizationData] = useState({
        idCustomization: "",
        idUtente: "",
        idBasicModel: 0,
        moodType: "",
        language: ""
    });

    const customizationCtx = useContext(CustomizationContext);
    const localizationCtx = useContext(LocalizationContext);


    const startConfiguration = async () => {
        setIsLoading(true);
        const response = await fetch("/api/customization/start/" + props.modelCode + "/" + props.cultureCode);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                customizationCtx.updateCustomizationData(data);
                setCustomizationData(data);
                setIsLoading(false);
                props.updateStepCallBack(1);
            } else {
                setIsLoading(false);
                props.feedbackCallback("error", "Error initializing configuration", true);
            }

        } else {
            setIsLoading(false);
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }


    }

    const handleStartConfiguration = () => {
        startConfiguration();
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (props.modelCode === "Infynito90") {
            setUrlMainImage("/images/Infynito90/main2.jpg");
        }

        if (props.modelCode === "Infynito80") {
            setUrlMainImage("/images/Infynito80/main2.jpg");
        }


    }, []);



    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'white',
        boxShadow: 24,
        p: 4,
    };

    const handleClose = () => {
        setIsLoading(false);
    }

    return (
        <>
            <div className="content-wrap bkg-deep-ocean">
                <div className="container-fluid bkg-dark-ocean py-5">
                    <div className="row">
                        <div className="col-12 px-0 d-block d-lg-none pb-5"><img alt="Main image" className="d-block w-100" src={urlMainImage} /></div>
                        <div className="col-lg-4 col-12 bkg-dark-ocean text-white px-5 pt-0">
                            <p className="text-intro-configurator pr-lg-5 mr-lg-5">{Parser().parse(localizationCtx.localizationData.payOff)}</p>
                            <List sx={{ width: '100%' }}>
                                <ListItem key="001"  >
                                    <ListItemAvatar>
                                        <div className="text-step-configurator">
                                            <Icon size={32} icon={numberOne} />
                                        </div>
                                    </ListItemAvatar>
                                    <ListItemText primaryTypographyProps={{ fontSize: '1.5rem' }} primary={localizationCtx.localizationData.actionConfigure} />
                                </ListItem>
                                <ListItem key="002">
                                    <ListItemAvatar>
                                        <div className="text-step-configurator">
                                            <Icon size={32} icon={numberTwo} />
                                        </div>
                                    </ListItemAvatar>
                                    <ListItemText primaryTypographyProps={{ fontSize: '1.5rem' }} primary={localizationCtx.localizationData.actionReview} />
                                </ListItem>
                                <ListItem key="003">
                                    <ListItemAvatar>
                                        <div className="text-step-configurator">
                                            <Icon size={32} icon={numberThree} />
                                        </div>
                                    </ListItemAvatar>
                                    <ListItemText primaryTypographyProps={{ fontSize: '1.5rem' }} primary={localizationCtx.localizationData.actionSend} />
                                </ListItem>
                            </List>
                            <div className="div-button-start">
                                <a className="flat-white-button text-uppercase mt-5" onClick={handleStartConfiguration}>{localizationCtx.localizationData.actionStart}</a>
                            </div>
                        </div>
                        <div className="d-block d-sm-none text-white py-5">
                            <p className="text-intro pr-lg-5 mr-lg-5">{localizationCtx.localizationData.landascapeMode}</p>
                        </div>
                        <div className="col-lg-8 px-0 d-none d-lg-block"><img alt="Main image" className="d-block w-100" src={urlMainImage} /></div>
                    </div>


                    <Modal
                        open={isLoading}
                        onClose={handleClose}
                    >

                        <Box sx={style}>
                            <LoadingInfynito message={localizationCtx.localizationData.loadingStart} />
                        </Box>

                    </Modal>

                </div>
            </div>
            <FooterFerrettiInfynito cultureCode={props.cultureCode} />
        </>
    );
};

export default Intro;
